<section>
    <h1>Ett fel uppstod (500)</h1>
    <p>Vi ber om ursäkt, men ett fel verkar ha uppstått. Du kan försöka <a [routerLink]="['/admin']">ta dig till startsidan</a> eller kontakta <a href="mailto:support@basetool.se">support@basetool.se</a> för att få hjälp.</p>
</section>